import { render, staticRenderFns } from "./RecebimentoReport.vue?vue&type=template&id=3f464286&scoped=true"
import script from "./RecebimentoReport.vue?vue&type=script&lang=ts"
export * from "./RecebimentoReport.vue?vue&type=script&lang=ts"
import style0 from "./RecebimentoReport.vue?vue&type=style&index=0&id=3f464286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f464286",
  null
  
)

export default component.exports